import { ReactNode } from "react";
import Post from "../../../components/post";
import config from "react-global-configuration";
import { NewsEntity } from "../../../types/newsEntity";
import { isMobile } from "react-device-detect";
import { sanitizeNewsHtml } from "../../../utils/sanitizeHtml";

const MAX_IMAGE_HEIGHT = 500;
const getImageHeight = (
  image: { height: number; href: string } | null | undefined
) => {
  if (image) {
    if (image.height > MAX_IMAGE_HEIGHT) {
      return MAX_IMAGE_HEIGHT;
    } else {
      return image.height;
    }
  } else {
    return 0;
  }
};

type NewsPostProps = {
  singleNews: NewsEntity;
  // False on the article page itself, where the title shouldn't link back to it.
  linked?: boolean;
  actions?: ReactNode;
};

const NewsPost = ({ singleNews, linked = true, actions }: NewsPostProps) => {
  const imageHeight = getImageHeight(singleNews.image);

  return (
    <Post
      key={singleNews.id}
      id={singleNews.id}
      href={linked ? `/news/${singleNews.id}` : undefined}
      title={singleNews.name}
      date={singleNews.inserted}
      dateFormatted={singleNews.insertedString}
      author={singleNews.author}
      body={
        <p
          style={
            !isMobile && singleNews.image && singleNews.imageAlign !== 4
              ? { minHeight: imageHeight - 50 }
              : undefined
          }
        >
          {!isMobile && singleNews.image && singleNews.imageAlign !== 4 ? (
            <span
              className={
                singleNews.imageAlign === 1
                  ? "image left"
                  : singleNews.imageAlign === 2
                    ? "image right"
                    : undefined
              }
            >
              <img
                // Width follows the height cap so portrait images keep their proportions.
                style={{
                  maxHeight: `${imageHeight}px`,
                  width: "auto",
                  maxWidth: "100%",
                }}
                src={`${
                  config.get("apiPath") + singleNews.image.href
                }?width=${MAX_IMAGE_HEIGHT}`}
                alt={singleNews.name}
              />
            </span>
          ) : null}
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeNewsHtml(singleNews.content),
            }}
          />{" "}
          {/* skipcq: JS-0440 */}
        </p>
      }
      image={
        singleNews.image && (isMobile || singleNews.imageAlign === 4)
          ? `${config.get("apiPath") + singleNews.image.href}?width=1400`
          : null
      }
      actions={actions ?? <p />}
    />
  );
};

export default NewsPost;
